import React from 'react';
import propTypes from 'prop-types';

export const CreditIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 60 60"
      enableBackground="new 0 0 60 60;"
      // style="enable-background:new 0 0 60 60;"
      xmlSpace="preserve"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
    >
      <g>
        <rect x="46" y="39" width="7" height="4" />
        <rect x="20" y="39" width="7" height="4" />
        <rect x="7" y="39" width="7" height="4" />
        <rect x="33" y="39" width="7" height="4" />
        <rect x="39" y="17" width="14" height="8" />
        <path
          d="M55.783,8H4.217C1.892,8,0,9.892,0,12.217v35.566C0,50.108,1.892,52,4.217,52h51.566C58.108,52,60,50.108,60,47.783V12.217
     C60,9.892,58.108,8,55.783,8z M6,16h9c0.553,0,1,0.448,1,1s-0.447,1-1,1H6c-0.553,0-1-0.448-1-1S5.447,16,6,16z M14,22
     c0,0.552-0.447,1-1,1h-2c-0.553,0-1-0.448-1-1s0.447-1,1-1h2C13.553,21,14,21.448,14,22z M6,21h1c0.553,0,1,0.448,1,1s-0.447,1-1,1
     H6c-0.553,0-1-0.448-1-1S5.447,21,6,21z M16,45H5v-8h11V45z M16,22c0-0.552,0.447-1,1-1h1c0.553,0,1,0.448,1,1s-0.447,1-1,1h-1
     C16.447,23,16,22.552,16,22z M29,45H18v-8h11V45z M21,22c0-0.552,0.447-1,1-1h2c0.553,0,1,0.448,1,1s-0.447,1-1,1h-2
     C21.447,23,21,22.552,21,22z M28.71,22.71C28.52,22.89,28.27,23,28,23c-0.26,0-0.521-0.11-0.71-0.29C27.109,22.52,27,22.26,27,22
     c0-0.26,0.109-0.52,0.29-0.71c0.37-0.37,1.04-0.37,1.42,0C28.89,21.48,29,21.74,29,22C29,22.26,28.89,22.52,28.71,22.71z M28,18h-9
     c-0.553,0-1-0.448-1-1s0.447-1,1-1h9c0.553,0,1,0.448,1,1S28.553,18,28,18z M42,45H31v-8h11V45z M55,45H44v-8h11V45z M55,27H37V15
     h18V27z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
CreditIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
CreditIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
